/* New art template only. Prices and selected contents come from Shopify Section Rendering. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || !root.customElements) return;
  root.customElements.whenDefined('variant-radios').then(() => {
    if (root.customElements.get('mp-art-variant-picker')) return;
    const NativePicker = root.customElements.get('variant-radios');
    class ArtVariantPicker extends NativePicker {
      connectedCallback() {
        if (this.artReady) return;
        this.artReady = true;
        this.artPreviewPath =  /\/products_preview\/?$/.test(location.pathname) ? location.pathname : null;
        this.artMedia = JSON.parse(this.querySelector('[data-art-media]')?.textContent || '{}');
        this.form = document.getElementById(`product-form-${this.dataset.section}`);
        this.guard = event => {
          if (!this.currentVariant?.available || !this.allowed(this.currentVariant) || this.dataset.busy === 'true') {
            event.preventDefault(); event.stopImmediatePropagation();
            this.announce(this.dataset.unavailable);
          }
        };
        this.form?.addEventListener('submit', this.guard, true);
        const requestedId = new URL(location.href).searchParams.get('variant');
        const requested = requestedId && this.getVariantData().find(variant => String(variant.id) === requestedId);
        if (requested && !this.allowed(requested)) {
          // An explicit stale country/format link must require a deliberate
          // choice. Never change a local price into an international variant.
          const index = Number(this.dataset.frameIndex);
          const fieldset = [...this.querySelectorAll('fieldset')][Number.isInteger(index) ? index : 0];
          fieldset?.querySelectorAll('input:checked').forEach(input => { input.checked = false; });
        }
        this.updateOptions(); this.updateMasterId(); this.updateVariantStatuses();
      }
      disconnectedCallback() {
        this.artRequest?.abort();
        this.form?.removeEventListener('submit', this.guard, true);
        this.artReady = false;
      }
      allowed(variant) {
        return api.isAllowedVariant(variant, { premium: this.dataset.premium === 'true', local: this.dataset.local === 'true', supportedForeign: this.dataset.foreignSupported !== 'false', frameIndex: this.dataset.frameIndex === '' ? null : Number(this.dataset.frameIndex), sizeIndex: Number(this.dataset.sizeIndex || 0) });
      }
      updateOptions() {
        // A retired format may still be present in an old link. Leave its size
        // unselected, rather than substituting another size or throwing.
        this.options = [...this.querySelectorAll('fieldset')].map(fieldset => fieldset.querySelector('input:checked')?.value);
      }
      updateMasterId() {
        // Native translated option labels can coincide. IDs/SKUs and country
        // eligibility distinguish local and Gelato fulfillment variants.
        this.currentVariant = this.getVariantData().find(variant => this.allowed(variant) && variant.options.every((option, index) => option === this.options[index]));
      }
      updateVariantStatuses() {
        const fieldsets = [...this.querySelectorAll('fieldset')];
        const selected = fieldsets.map(fieldset => fieldset.querySelector('input:checked')?.value);
        const variants = this.getVariantData();
        fieldsets.forEach((fieldset, index) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
            const available = api.canSelectOption(variants, selected, index, input.value, variant => this.allowed(variant), { allowIncomplete: this.dataset.premium === 'true' });
            input.disabled = !available;
            input.setAttribute('aria-disabled', String(!available));
            input.classList.toggle('disabled', !available);
          });
        });
      }
      updateURL() {
        if (!this.currentVariant) return;
        const url = new URL(location.href);
        url.searchParams.set('variant', this.currentVariant.id);
        history.replaceState({}, '', url.pathname + url.search);
      }
      updateMedia() {
        const media = this.artMedia[String(this.currentVariant?.id)];
        const gallery = document.querySelector(`[data-mp-gallery][data-section="${this.dataset.section}"]`);
        const target = gallery?.querySelector('.mp-gallery-main');
        if (!media || !target) return;
        if (media.srcset) target.srcset = media.srcset; else target.removeAttribute('srcset');
        target.src = media.src; target.alt = media.alt;
        target.width = media.width; target.height = media.height;
        gallery.querySelectorAll('[data-mp-thumb]').forEach(button => {
          const source = button.querySelector('img');
          const same = source && new URL(button.dataset.mpFull || source.src, location.origin).pathname === new URL(media.src, location.origin).pathname;
          button.setAttribute('aria-pressed', String(Boolean(same)));
        });
      }
      announce(message) {
        const status = document.getElementById(`ArtVariantStatus-${this.dataset.section}`);
        if (status) status.textContent = message || '';
      }
      setUnavailable() {
        super.setUnavailable();
        this.artRequest?.abort(); this.dataset.busy = 'false'; this.removeAttribute('aria-busy');
        for (const prefix of ['price', 'ArtSelection', 'ArtDelivery']) {
          const content = document.getElementById(`${prefix}-${this.dataset.section}`);
          if (content) content.hidden = true;
        }
        const warning = document.getElementById(`ArtWarning-${this.dataset.section}`);
        if (warning) warning.hidden = false;
        const input = this.form?.querySelector('[name="id"]');
        if (input) input.value = '';
        this.announce(this.dataset.unavailable);
      }
      async renderProductInfo() {
        const requested = this.currentVariant.id;
        this.artRequest?.abort(); this.artRequest = new AbortController();
        const controller = this.artRequest;
        this.dataset.busy = 'true'; this.setAttribute('aria-busy', 'true');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.hidden = true;
        try {
          // Keep the selected market/language web presence and preview key.
          // A native product URL can omit the current locale subfolder.
          const url = new URL(location.pathname, location.origin);
          url.search = location.search;
          url.searchParams.set('variant', requested);
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Section Rendering failed');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (this.currentVariant?.id !== requested) return;
          const renderedPicker = page.getElementById(this.id);
          if (!api.sameRenderContext(this.dataset, renderedPicker?.dataset)) throw new Error('Section Rendering context changed');
          for (const prefix of ['price', 'ArtSelection', 'ArtGalleryCaption', 'ArtDelivery', 'ArtWarning', 'ArtQuality', 'ArtProcess']) {
            const id = `${prefix}-${this.dataset.section}`;
            const source = page.getElementById(id), destination = document.getElementById(id);
            if (!source || !destination) throw new Error(`Missing section element ${prefix}`);
            destination.innerHTML = source.innerHTML;
            destination.hidden = source.hidden;
            destination.classList.remove('visibility-hidden');
          }
          const button = page.getElementById(`ProductSubmitButton-${this.dataset.section}`);
          if (!button) throw new Error('Missing native product button');
          this.toggleAddButton(button.disabled || !this.currentVariant.available || !this.allowed(this.currentVariant), button.querySelector('span')?.textContent);
          this.announce(this.currentVariant.options.join(' · '));
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.toggleAddButton(true, this.dataset.error);
          this.announce(this.dataset.error);
        } finally {
          if (this.artRequest === controller) {
            this.dataset.busy = 'false'; this.removeAttribute('aria-busy');
          }
        }
      }
    }
    root.customElements.define('mp-art-variant-picker', ArtVariantPicker);
  });
})(typeof window === 'undefined' ? {} : window, function () {
  const unframed = new Set(['ohne rahmen', 'without frame', 'unframed', 'no frame', 'sin marco', 'sans cadre', 'senza cornice', 'без рамки']);
  function normalizeSize(value) {
    return String(value || '').toLowerCase().replace(/\s/g, '').replace(/×/g, 'x').replace(/,/g, '.').replace(/cm|mm/g, '');
  }
  function isAllowedVariant(variant, context = {}) {
    if (!variant) return false;
    if (context.premium) {
      if (!context.local && context.supportedForeign === false) return false;
      const size = normalizeSize(variant.options[context.sizeIndex || 0]);
      // Stock, price, fulfillment and the exact frame combination always come
      // from the native Shopify variant. Never turn 40x60 into 45x60.
      const b0 = ['b0', '100x140', '1000x1400'].includes(size) || /^b0[·(]/.test(size);
      if (b0 && !context.local) return false;
      if (!b0 && !['30x40', '45x60', '50x70', '70x100'].includes(size)) return false;
      if (Number.isInteger(context.frameIndex)) {
        const frame = String(variant.options[context.frameIndex] || '').toLowerCase().trim();
        const premiumFrames = new Set('ohne rahmen,without frame,unframed,no frame,sin marco,sans cadre,senza cornice,без рамки,schwarz,black,negro,noir,nero,чорний,weiß,weiss,white,blanco,blanc,bianco,білий,natur,naturholz,wood,natural wood,natural,bois naturel,madera natural,legno naturale,натуральне дерево'.split(','));
        if (!premiumFrames.has(frame)) return false;
        if (b0 && !unframed.has(frame)) return false;
        if (unframed.has(frame)) {
          const foreignOnly = String(variant.sku || '').endsWith('-INT');
          if (foreignOnly === Boolean(context.local)) return false;
        }
      }
      return true;
    }
    if (context.frameIndex === null || !Number.isInteger(context.frameIndex)) return true;
    const frame = String(variant.options[context.frameIndex] || '').toLowerCase().trim();
    if (unframed.has(frame)) return true;
    const size = String(variant.options[context.sizeIndex || 0] || '').replace(/\s/g, '').replace(/×/g, 'x');
    return !context.local && !/40x60|60x40/.test(size);
  }
  function canSelectOption(variants, selected, index, value, allowed = () => true, context = {}) {
    return variants.some(variant => variant.available && allowed(variant) && (context.allowIncomplete
      ? variant.options[index] === value
      : variant.options.every((option, position) => option === (position === index ? value : selected[position]))));
  }
  function sameRenderContext(current, rendered) {
    return Boolean(current?.country && current?.language && rendered?.country === current.country && rendered?.language === current.language);
  }
  return { normalizeSize, isAllowedVariant, canSelectOption, sameRenderContext };
});
